(function(){
  var header = document.getElementById('header-component');
  if (!header) return;
  var headerSection = header.closest('.header-section');
  var rows = header.querySelectorAll('.header__row');
  var isHome = header.hasAttribute('transparent');
  var announcementBar = document.querySelector('.shopify-section-group-header-group:not(.header-section)');
  var abHeight = announcementBar ? announcementBar.offsetHeight : 0;
  var headerHeight = headerSection.offsetHeight;
  var lastState = null;

  var s = document.createElement('style');
  s.textContent = [
    /* Header sticky */
    '.header-section { position: fixed !important; left: 0 !important; right: 0 !important; width: 100% !important; z-index: 999 !important; transition: top 0.25s ease, background 0.25s ease !important; }',
    '.header-section .header { opacity: 1 !important; transition: none !important; }',
    '.header-section .header__row { transition: background-color 0.25s ease, box-shadow 0.25s ease !important; }',
    '.header-section.header-white .header__row { background-color: #fff !important; box-shadow: 0 2px 8px rgba(0,0,0,.08) !important; }',
    '.header-section.header-transparent .header__row { background-color: transparent !important; box-shadow: none !important; }',
    '.header-section.header-white #header-component { --color-foreground: #000; --color-foreground-rgb: 0,0,0; }',
    '.header-section.header-transparent #header-component { --color-foreground: #fff; --color-foreground-rgb: 255,255,255; }',

    /* Menu principal compact */
    '.menu-list__link { font-size: 0.8rem !important; padding-inline: 8px !important; }',

    /* Submenu */
    '.menu-list__submenu { background: transparent !important; }',
    '.menu-list__submenu-inner { background: transparent !important; padding: 0 !important; }',

    /* Mega-menu */
    '.mega-menu.section { background: #fff !important; border-radius: 0 0 12px 12px !important; box-shadow: 0 10px 40px rgba(0,0,0,0.1) !important; border-top: 3px solid #FF6B00 !important; padding: 14px 40px !important; margin: 0 !important; }',
    '.mega-menu__grid { display: flex !important; justify-content: center !important; }',
    '.mega-menu__list { display: flex !important; flex-direction: row !important; flex-wrap: wrap !important; gap: 0 8px !important; justify-content: center !important; }',
    '.mega-menu__column { display: contents !important; }',
    '.mega-menu__column > div { margin: 0 !important; }',
    '.mega-menu__link { color: #333 !important; padding: 8px 18px !important; border-radius: 8px !important; transition: all 0.15s ease !important; text-decoration: none !important; white-space: nowrap !important; display: inline-flex !important; }',
    '.mega-menu__link:hover { color: #FF6B00 !important; background: #FFF5EE !important; }',
    '.mega-menu__link-title { font-weight: 500 !important; font-size: 13px !important; letter-spacing: 0.04em !important; white-space: nowrap !important; }'
  ].join('');
  document.head.appendChild(s);

  headerSection.style.top = abHeight + 'px';

  // Pages non-homepage : compenser le menu fixé
  if (!isHome) {
    headerSection.classList.add('header-white');
    headerSection.style.background = '#fff';
    var content = document.querySelector('.content-for-layout');
    if (content) content.style.paddingTop = headerHeight + 'px';
  }

  function update() {
    var scrolled = window.scrollY > abHeight;
    var newState = (!scrolled && isHome) ? 'transparent' : 'white';

    if (newState === lastState && scrolled === (headerSection.style.top === '0px')) return;
    lastState = newState;

    headerSection.style.top = scrolled ? '0px' : abHeight + 'px';
    headerSection.classList.remove('header-white', 'header-transparent');
    headerSection.classList.add('header-' + newState);
    headerSection.style.background = newState === 'white' ? '#fff' : 'transparent';
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
})();